export default __webpack_public_path__ + "static/media/optimism.2496e481.svg";